// One-click PDF download of the currently open letter/payslip dialog.
// Captures the visible `.print-area` inside the open dialog and saves a true PDF file.
export async function downloadLetterPdf(filename) {
  const el = document.querySelector('[role="dialog"] .print-area');
  if (!el) {
    window.print();
    return;
  }
  try {
    const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
      import("html2canvas"),
      import("jspdf"),
    ]);
    const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
    const img = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pw = pdf.internal.pageSize.getWidth();
    const ph = pdf.internal.pageSize.getHeight();
    const ih = (canvas.height * pw) / canvas.width;
    let heightLeft = ih;
    let position = 0;
    pdf.addImage(img, "PNG", 0, position, pw, ih);
    heightLeft -= ph;
    while (heightLeft > 0) {
      position -= ph;
      pdf.addPage();
      pdf.addImage(img, "PNG", 0, position, pw, ih);
      heightLeft -= ph;
    }
    pdf.save(filename);
  } catch (e) {
    // Fallback to the browser print dialog if canvas rendering fails.
    window.print();
  }
}
